const PAXSGROUP_UPDATED = (state, PaxsGroup) => {
  state.PaxsGroup = PaxsGroup
}

export default {
  PAXSGROUP_UPDATED
}
